
//import randomLocation from "random-location";
//import {Map} from "./Map";
// import { render } from "react-dom";
// import React from "react";
export function renderToDOM(container) {
  const DATA_URL = "./data/outages.csv"; // eslint-disable-line
  const {Map} = require('./Map');
  const randomLocation = require('random-location');
  const React = require('react');
  const ReactDOM = require('react-dom');
  
  require("d3-request").csv(DATA_URL, (error, response) => {
    if (!error) {
      const data = response.map(row => {
        const randomLoc = randomLocation.randomCirclePoint(
          {
            latitude: row.latitude,
            longitude: row.longitude
          },
          3500
        );
        return {
          RecordedDateTime: new Date(`${row.RecordedDateTime}`),
          latitude: randomLoc.latitude,
          longitude: randomLoc.longitude,
          CustomersAffected: Number(row.CustomersAffected),
          CountyName: row.CountyName,
          StateName: row.StateName,
          CityName: row.CityName,
          UtilityName: row.UtilityName
        };
      });

      const dateSortedData = data
        .slice()
        .sort((a, b) => b.RecordedDateTime - a.RecordedDateTime);

        ReactDOM.render(<Map data={dateSortedData} />, container);
    }
  });
}
